import {
  Action,
  mkWidget,
  route,
  loadingAsyncState,
  async,
  unloadedAsyncState,
  HttpResult
} from 'widgets-for-react'
import React from 'react'
import { styleguide as SG } from '../../../styleguide/main'

import { CustomRouteParams } from '../../cms/router/type.gen'
import { PublicSiteCustomRoutes, CustomPagesState, CustomPage } from './types.mod'
import { PublicSiteState } from '../../public_site.main.mod'
import { searchResults } from '../../searchResults'
import { WordPress } from '../../wordpress/wordpress_api'
import { AxiosResponse } from 'axios'

export const styleguide: CustomPage<CustomPagesState['styleguide']> = {
  widget: () => SG.never(),
  route: route<{}, CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>>(
    '/styleguide',
    () => ({
      kind: 'styleguide'
    })
  ),
  getState: (s: PublicSiteState) => s.styleguide,
  setState: (s: PublicSiteState, ss: {}) => ({ ...s, styleguide: ss }),
  updateStateBasesOnRoute: (s, r) =>
    r.kind != 'styleguide' ? s : { ...s, styleguide: { ...s.styleguide } }
}

export const custom_page2: CustomPage<CustomPagesState['custom_page2']> = {
  widget: r =>
    mkWidget({
      run: (setState: (_: Action<CustomPagesState['custom_page2']>) => void) => {
        let get_remote_random_number: () => Promise<HttpResult<number>> = async () => {
          //we simulate a fetch
          await new Promise(res => setTimeout(res, Math.round(Math.random() * 5000)))
          return {
            kind: 'result',
            status: 200,
            value: Math.round(Math.random() * 100)
          }
        }

        let custom_page2_state = r.snd
        return (
          <div>
            {async<number>()(custom_page2_state.get_random_number).run(res =>
              setState(s => {
                let new_async_state = res(s.get_random_number)
                if (new_async_state.kind == 'loaded')
                  return {
                    ...s,
                    page: new_async_state.value,
                    get_random_number: unloadedAsyncState()
                  }
                else return { ...s, get_random_number: new_async_state }
              })
            )}
            <h2>Hello custom_page2</h2>
            <p>This is a custom page made with a JSX elements</p>
            <p>You input page is {custom_page2_state.page}</p>
            <div>
              <p>Click this button to increment the page number </p>
              <button onClick={() => setState(s => ({ ...s, page: s.page + 1 }))}>Click me!</button>
            </div>

            <div>
              <p>Click this other button to get a random number from the api</p>
              <button
                disabled={
                  custom_page2_state.get_random_number.kind == 'loading' ||
                  custom_page2_state.get_random_number.kind == 'connection-error'
                }
                onClick={() =>
                  setState(s => ({
                    ...s,
                    get_random_number: loadingAsyncState(get_remote_random_number)
                  }))
                }
              >
                Click me!
              </button>
            </div>
          </div>
        )
      }
    }),
  route: route<{ page: string }, CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>>(
    '/custom_page2/:page',
    s => ({ kind: 'custom_page2', page: s.page && parseInt(s.page) })
  ),
  getState: (s: PublicSiteState) => s.custom_page2,
  setState: (s: PublicSiteState, ss: CustomPagesState['custom_page2']) => ({
    ...s,
    custom_page2: ss
  }),
  updateStateBasesOnRoute: (s, r) =>
    r.kind != 'custom_page2'
      ? s
      : { ...s, custom_page2: { page: r.page, get_random_number: unloadedAsyncState() } }
}

export const search: CustomPage<CustomPagesState['search']> = {
  widget: searchResults,
  route: route<{ term: string }, CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>>(
    '/zoeken/:term*',
    s => ({ kind: 'search', term: s.term || ''})
  ),
  getState: (s: PublicSiteState) => ({ ...s.search, header: s.header }),
  setState: (s: PublicSiteState, ss: CustomPagesState['search']) => ({
    ...s,
    search: ss,
    header: ss.header
  }),
  updateStateBasesOnRoute: (s, r) => {
    return r.kind != 'search'
      ? s
      : {
          ...s,
          header: {
            ...s.header,
            searchValue: r.term
          },
          search: {
            header: s.header,
            results: loadingAsyncState(async () => {
              let result: AxiosResponse<WordPress.PostTypeResponse[]> = {} as AxiosResponse<WordPress.PostTypeResponse[]>
              if (r.term) {
                result = await WordPress.api().search(r.term)
              }
              return { kind: 'result', status: 200, value: result }
            })
          }
        }
  }
}



// WEBPACK FOOTER //
// ./Client/components/public_site/custom_pages/custom_pages.mod.tsx